
 
    // ── Mobile nav ──
    function toggleMobileMenu() {
      const menu = document.getElementById('mobile-menu');
      menu.classList.toggle('open');
    }
    function closeMobileMenu() {
      document.getElementById('mobile-menu').classList.remove('open');
    }

    // ── Enable animations only after JS loads (prevents flash of invisible content) ──
    document.documentElement.classList.add('js-loaded');

    // ── Hero image entrance ──
    setTimeout(() => {
      const heroImg = document.getElementById('hero-img');
      if (heroImg) heroImg.classList.add('visible');
    }, 300);

    
 